import React, { useMemo, useState } from "react";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { useSearchParams } from "react-router-dom";

export default function CostCentersTable({ data, rows }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [paginationModel, setPaginationModel] = useState({
    page: Number(searchParams.get("page") ?? 1) - 1,
    pageSize: Number(searchParams.get("page_size") ?? 50),
  });

  const handlePaginationModelChange = paginationModel => {
    searchParams.set("page", paginationModel.page + 1);
    searchParams.set("page_size", paginationModel.pageSize);

    setSearchParams(searchParams);
    setPaginationModel(paginationModel);
  };

  const columns = useMemo(
    () => [
      {
        headerName: "Filial",
        field: "subsidiary",
        flex: 1,
        renderCell: params => params.row?.CTT_FILIAL,
      },
      {
        headerName: "Código",
        field: "costCenterCode",
        flex: 1,
        renderCell: params => params.row?.CTT_CUSTO,
      },
      {
        headerName: "Descrição",
        field: "costCenterName",
        flex: 1,
        renderCell: params => params.row?.CTT_DESC01,
      },
      // {
      //   field: "actions",
      //   type: "actions",
      //   headerName: "Ações",
      //   width: 70,
      //   getActions: params => [
      //     <GridActionsCellItem
      //       onClick={() => {
      //         searchParams.set("cost_center_id", params.row.CTT_CUSTO);
      //         setSearchParams(searchParams);
      //       }}
      //       label="Editar"
      //       showInMenu
      //     />,
      //   ],
      // },
    ],
    [searchParams, setSearchParams],
  );

  return (
    <DataGrid
      rows={data}
      columns={columns}
      getRowId={row => row.R_E_C_N_O_}
      sx={{ flex: 1, border: "none" }}
      disableColumnMenu
      disableColumnFilter
      disableColumnSelector
      disableRowSelectionOnClick
      rowCount={rows}
      paginationMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={handlePaginationModelChange}
    />
  );
}
